import { HttpMethod } from "../../components/Common/useFetch";
import { RequestOptions } from "../../components/Common/useRequest";
import useKaEmployeeRequest, { KaEmployeeRequestSpec } from "../../components/Common/useKaEmployeeRequest";
import { UpsertSiteDto } from "./useCreateSite";

const updateSpec = (siteId: string): KaEmployeeRequestSpec => ({
  path: `/employeeApi/sites/${siteId}`,
  method: HttpMethod.PUT,
});

const useUpdateSite = (siteId: string, options?: RequestOptions<void>) => {
  return useKaEmployeeRequest<UpsertSiteDto>(updateSpec(siteId), options);
}

export default useUpdateSite;
